
import { useState } from "react";
import LoginModal from "./LoginModal";

export default function Header() {
  const [showLogin, setShowLogin] = useState(false);

  return (
    <>
  <header
  className="
    absolute
    left-3
    right-3
    top-3
    z-30

    flex
    flex-wrap
    items-center
    justify-center
    gap-5

    sm:left-5
    sm:right-5
    sm:top-5
    sm:gap-4

    xl:left-8
    xl:right-8
    xl:top-8
  "
>
        {/* SAMVERKANDE PARTNERS */}
        <div
          className="
            min-w-0
            w-full
            rounded-2xl
            border
            border-white/80
            bg-white/85
            px-2
            py-2
            shadow-sm
            backdrop-blur

            sm:px-3
            sm:py-2.5

            md:w-auto
            md:px-4
            md:py-3

            xl:px-5
            xl:py-3
          "
        >
          <div
            className="
              flex
              min-w-0
              items-center
              justify-center
              gap-1.5

              sm:gap-2

              md:gap-3

              xl:gap-5
            "
          >
            {/* LOGO 1 */}
            <img
              src="/Image1.jpg"
              alt="Samverkande partner"
              className="
                h-5
                w-auto
                max-w-[13vw]
                min-w-0
                object-contain

                sm:h-7

                md:h-8
                md:max-w-none

                xl:h-10
              "
            />

            <span className="h-4 w-px shrink-0 bg-neutral-200 sm:h-5 md:h-6 xl:h-7" />

            {/* LOGO 2 */}
            <img
              src="/Image2.png"
              alt="Samverkande partner"
              className="
                h-5
                w-auto
                max-w-[13vw]
                min-w-0
                object-contain

                sm:h-7

                md:h-8
                md:max-w-none

                xl:h-10
              "
            />

            <span className="h-4 w-px shrink-0 bg-neutral-200 sm:h-5 md:h-6 xl:h-7" />

            {/* LOGO 3 */}
            <img
              src="/Image3.png"
              alt="Samverkande partner"
              className="
                h-5
                w-auto
                max-w-[13vw]
                min-w-0
                object-contain

                sm:h-7

                md:h-8
                md:max-w-none

                xl:h-10
              "
            />

            <span className="h-4 w-px shrink-0 bg-neutral-200 sm:h-5 md:h-6 xl:h-7" />

            {/* LOGO 4 */}
            <img
              src="/Image6.png"
              alt="Samverkande partner"
              className="
                h-5
                w-auto
                max-w-[13vw]
                min-w-0
                object-contain

                sm:h-7

                md:h-8
                md:max-w-none

                xl:h-10
              "
            />

            <span className="h-4 w-px shrink-0 bg-neutral-200 sm:h-5 md:h-6 xl:h-7" />

            {/* LOGO 5 */}
            <img
              src="/Image7.png"
              alt="Samverkande partner"
              className="
                h-5
                w-auto
                max-w-[13vw]
                min-w-0
                object-contain

                sm:h-7

                md:h-8
                md:max-w-none

                xl:h-10
              "
            />

            <span className="h-4 w-px shrink-0 bg-neutral-200 sm:h-5 md:h-6 xl:h-7" />

            {/* LOGO 6 */}
            <img
              src="/Image4.jpg"
              alt="Samverkande partner"
              className="
                h-5
                w-auto
                max-w-[13vw]
                min-w-0
                object-contain

                sm:h-7

                md:h-8
                md:max-w-none

                xl:h-10
              "
            />

            <span className="h-4 w-px shrink-0 bg-neutral-200 sm:h-5 md:h-6 xl:h-7" />

            {/* LOGO 7 */}
            <img
              src="/Image5.png"
              alt="Samverkande partner"
              className="
                h-5
                w-auto
                max-w-[13vw]
                min-w-0
                object-contain

                sm:h-7

                md:h-8
                md:max-w-none

                xl:h-10
              "
            />
          </div>
        </div>

        {/* LOGIN */}
     <div
  className="
    flex
    w-full
    justify-end
    mt-6

    sm:w-auto
    sm:mt-0
  "
>
  
        </div>
      </header>

      {/* LOGIN MODAL */}
      {showLogin && (
        <LoginModal
          onClose={() => setShowLogin(false)}
        />
      )}
    </>
  );
}
